<template>
  <modal
    name="advancedSearchSaveModal"
    classes="v--modal vue-dialog"
    height="auto"
    :width="null"
    :pivotX="0"
    @before-open="beforeOpen"
  >
    <div slot="top-right">
    </div>
    <div class="dialog-content">
      <div class="dialog-c-title">
        Entrez le nom sous lequel vous souhaitez enregistrer votre recherche :
      </div>
      <div class="dialog-c-text"><input v-model="name"></div>
      <div class="error">{{ error }}</div>
    </div>
    <div class="dialog-buttons">
      <button @click="closeModal()">Annuler</button>
      <button @click="saveSearch()">Valider</button>
    </div>
  </modal>
</template>

<script>
import Users from '@/api/users.js'

export default {
  name: 'AdvancedSearchSaveModal',

  data () {
    return {
      name: null,
      error: null
    }
  },

  props: {
    type: String
  },

  methods: {
    beforeOpen () {
      this.name = null
      this.error = null
    },

    closeModal () {
      this.$modal.hide('advancedSearchSaveModal')
    },

    saveSearch () {
      if (this.name !== null) {
        let params = { ...this.$route.query }
        delete params.page

        Users.addSearch({
          name: this.name,
          search_type: this.type,
          search: JSON.stringify(params)
        })
          .then(() => this.flashSuccess('Recherche enregistrée'))
          .catch(error => { this.flashError(error.response.data) })
          .finally(this.closeModal())
      } else {
        this.error = 'Vous devez saisir un nom'
      }
    }
  }
}
</script>
